const en = {
    inv: 'Inventory',
    trade: 'Transaction',
    transfer: 'Transfer',
    temporary: 'Temporary',
    inbound: 'Inbound',
    outbound: 'Outbound',
    scanOrder: 'Scan order',
    inputOrder: 'Input order',
    beConfirmed: 'Doing',
    confirmed: 'Confirmed',
    invInProgress: 'Inventory in progress',
    genertDifferences: 'Generating differences',
    cpletDifIn: 'Complete differences inbound',
    cpletDifOut: 'Complete differences outbound',
    cplet: 'Completed',
    inboundSuccess: 'Inbound success',
    outboundSuccess: 'Outbound success',
    conIn: 'Confirm inbound',
    conOut: 'Confirm outbound',
    perOutbound: 'Pre Outbound',
    normalType: "Normal Material",
    completeType: "Finished Product",
    wastedType: "Scrap Material",
    tempType: "Temporary (Transfer) Location",
    locationType: "Location Type",
    outter: "External Location/Overseas Location",
    productionType: "Production Location",
    defectiveReturnType: "Defective Return Location",
    defectiveTempType: "Defective Temporary Location",
    locLocked: "Location locked / counting in progress",
    preOutExsist: "Pre-outbound exists at this location",
    locNull: "Location does not exist",
    proQtyFalse: "Product quantity mismatch",
    calcErr: "Error calculating order location",
    list: "History",
    batchAdd: "Inbound",
    adjust: "Outbound",
    count: "Count",
    batchNo: "Batch No.",
    opType: "Operation Type",
    beforeCount: "Quantity Before Change",
    changeCount: "Change Quantity",
    afterCount: "Quantity After Change",
    createdAt: "Created At",
    inventoryType: "In/Out Type",
};

export default en;